import { v4 } from 'uuid';
import { Skeleton } from '../ui/skeleton';
import { classes } from './DataList';
interface DataListSkeletonProps {
  length: number;
}
export function DataListSkeleton({
  length
}: DataListSkeletonProps) {
  return <div className={classes.group}>
      {new Array(length).fill(null).map(() => <div key={v4()} className={classes.item}>
          <span className={classes.label}>
            <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
          </span>
          <span className={classes.value}>
            <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
          </span>
        </div>)}
    </div>;
}